const contactUs = {
  title: "CONTACT US",
  forms: {
    student: "I am a student / a parent ",
    teacher: "I am a teacher",
    other: "Other",
  },
  faq: {
    title: "FAQ",
    sections: {
      password: {
        q: "I forgot my password",
        a: 'Go to your login page and click on "forgot password".',
      },
    },
  },
};

export default contactUs;
